module.exports = __webpack_public_path__ + "static/table-a9fa878b90a782f2bd0f5532f72ebb2e.jpg";